import { AppForm, AppFormItem, formRules } from 'shared/UI/UIKit/Form';
import { AppInput } from 'shared/UI/UIKit/Input';
import type { BuildingFormProps } from './types';

export const BuildingForm = (props: BuildingFormProps) => {
  return (
    <AppForm form={props.form}>
      <AppFormItem rules={formRules.required} label="Наименование здания" name="name">
        <AppInput placeholder="Введите название" />
      </AppFormItem>
      <AppFormItem label="Адрес" name="address">
        <AppInput placeholder="Введите адрес" />
      </AppFormItem>
    </AppForm>
  );
};
